import { cloneDeep } from 'lodash'

export const setClipPoster = ({ photoIndex, photos, setPhotos }) => {
  let photosClone = cloneDeep(photos)
  const photo = photosClone[photoIndex]

  if (photo.isClip) {
    photo.isClip = false
    photosClone[0].isClip = true
  } else {
    photosClone = photosClone.map((p, i) => {
      if (i === photoIndex) p.isClip = true
      else p.isClip = false
      return p
    })
  }

  setPhotos(photosClone)
}
